exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".topTab[data-v-1fbad4ad] {\n  border-bottom: 3px solid #505050;\n  padding-bottom: 20px;\n  margin-bottom: 10px;\n}\n", ""]);

// exports
